import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Story } from '../../models/story';
import { withStorySelectors } from './story.selectors';
import { StoryService } from '../../services/story/story.service';
import { inject } from '@angular/core';
import { ActiveUserStore } from '../user/active-user.state';
import { withLogging } from '../features/logger.feature';

export type StoryState = BaseState<Story>;

export const initialState: StoryState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Story',
  entityLabel: 'Bericht',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const StoryStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Story>(StoryService),
  withLogging(initialState.entityType),
  withStorySelectors(),
  withMethods((store, storyService = inject(StoryService)) => ({
    /**
     * fill pool state with pool-indicators
     */
    async findByCategoryIds(categoryIds: string[]) {
      patchState(store, { loading: true });

      const items = await storyService.getByCategoryIds(categoryIds);
      patchState(store, {
        items: items,
        loading: false,
        initialized: true,
        itemsLoaded: true,
      });
    },
  })),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      if (activeUserStore.canSeeAllInWorkspaceType('bookmarkCategory')) {
        store.loadAllItemsByPromise();
      }
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
